import type { ICountry } from '~/types/country/models'

export async function getCountryListData(): Promise<ICountry[]> {
  return [
    {
      id: 1,
      name: 'Afghanistan',
      iso2: 'AF',
      iso3: 'AFG',
      numericCode: '004',
    },
    {
      id: 2,
      name: 'Aland Islands',
      iso2: 'AX',
      iso3: 'ALA',
      numericCode: '248',
    },
    {
      id: 3,
      name: 'Albania',
      iso2: 'AL',
      iso3: 'ALB',
      numericCode: '008',
    },
    {
      id: 4,
      name: 'Algeria',
      iso2: 'DZ',
      iso3: 'DZA',
      numericCode: '012',
    },
    {
      id: 5,
      name: 'American Samoa',
      iso2: 'AS',
      iso3: 'ASM',
      numericCode: '016',
    },
    {
      id: 6,
      name: 'Andorra',
      iso2: 'AD',
      iso3: 'AND',
      numericCode: '020',
    },
    {
      id: 7,
      name: 'Angola',
      iso2: 'AO',
      iso3: 'AGO',
      numericCode: '024',
    },
    {
      id: 8,
      name: 'Anguilla',
      iso2: 'AI',
      iso3: 'AIA',
      numericCode: '660',
    },
    {
      id: 9,
      name: 'Antarctica',
      iso2: 'AQ',
      iso3: 'ATA',
      numericCode: '010',
    },
    {
      id: 10,
      name: 'Antigua and Barbuda',
      iso2: 'AG',
      iso3: 'ATG',
      numericCode: '028',
    },
    {
      id: 11,
      name: 'Argentina',
      iso2: 'AR',
      iso3: 'ARG',
      numericCode: '032',
    },
    {
      id: 12,
      name: 'Armenia',
      iso2: 'AM',
      iso3: 'ARM',
      numericCode: '051',
    },
    {
      id: 13,
      name: 'Aruba',
      iso2: 'AW',
      iso3: 'ABW',
      numericCode: '533',
    },
    {
      id: 14,
      name: 'Australia',
      iso2: 'AU',
      iso3: 'AUS',
      numericCode: '036',
    },
    {
      id: 15,
      name: 'Austria',
      iso2: 'AT',
      iso3: 'AUT',
      numericCode: '040',
    },
    {
      id: 16,
      name: 'Azerbaijan',
      iso2: 'AZ',
      iso3: 'AZE',
      numericCode: '031',
    },
    {
      id: 18,
      name: 'Bahrain',
      iso2: 'BH',
      iso3: 'BHR',
      numericCode: '048',
    },
    {
      id: 19,
      name: 'Bangladesh',
      iso2: 'BD',
      iso3: 'BGD',
      numericCode: '050',
    },
    {
      id: 20,
      name: 'Barbados',
      iso2: 'BB',
      iso3: 'BRB',
      numericCode: '052',
    },
    {
      id: 21,
      name: 'Belarus',
      iso2: 'BY',
      iso3: 'BLR',
      numericCode: '112',
    },
    {
      id: 22,
      name: 'Belgium',
      iso2: 'BE',
      iso3: 'BEL',
      numericCode: '056',
    },
    {
      id: 23,
      name: 'Belize',
      iso2: 'BZ',
      iso3: 'BLZ',
      numericCode: '084',
    },
    {
      id: 24,
      name: 'Benin',
      iso2: 'BJ',
      iso3: 'BEN',
      numericCode: '204',
    },
    {
      id: 25,
      name: 'Bermuda',
      iso2: 'BM',
      iso3: 'BMU',
      numericCode: '060',
    },
    {
      id: 26,
      name: 'Bhutan',
      iso2: 'BT',
      iso3: 'BTN',
      numericCode: '064',
    },
    {
      id: 27,
      name: 'Bolivia',
      iso2: 'BO',
      iso3: 'BOL',
      numericCode: '068',
    },
    {
      id: 155,
      name: 'Bonaire, Sint Eustatius and Saba',
      iso2: 'BQ',
      iso3: 'BES',
      numericCode: '535',
    },
    {
      id: 28,
      name: 'Bosnia and Herzegovina',
      iso2: 'BA',
      iso3: 'BIH',
      numericCode: '070',
    },
    {
      id: 29,
      name: 'Botswana',
      iso2: 'BW',
      iso3: 'BWA',
      numericCode: '072',
    },
    {
      id: 30,
      name: 'Bouvet Island',
      iso2: 'BV',
      iso3: 'BVT',
      numericCode: '074',
    },
    {
      id: 31,
      name: 'Brazil',
      iso2: 'BR',
      iso3: 'BRA',
      numericCode: '076',
    },
    {
      id: 32,
      name: 'British Indian Ocean Territory',
      iso2: 'IO',
      iso3: 'IOT',
      numericCode: '086',
    },
    {
      id: 33,
      name: 'Brunei',
      iso2: 'BN',
      iso3: 'BRN',
      numericCode: '096',
    },
    {
      id: 34,
      name: 'Bulgaria',
      iso2: 'BG',
      iso3: 'BGR',
      numericCode: '100',
    },
    {
      id: 35,
      name: 'Burkina Faso',
      iso2: 'BF',
      iso3: 'BFA',
      numericCode: '854',
    },
    {
      id: 36,
      name: 'Burundi',
      iso2: 'BI',
      iso3: 'BDI',
      numericCode: '108',
    },
    {
      id: 37,
      name: 'Cambodia',
      iso2: 'KH',
      iso3: 'KHM',
      numericCode: '116',
    },
    {
      id: 38,
      name: 'Cameroon',
      iso2: 'CM',
      iso3: 'CMR',
      numericCode: '120',
    },
    {
      id: 39,
      name: 'Canada',
      iso2: 'CA',
      iso3: 'CAN',
      numericCode: '124',
    },
    {
      id: 40,
      name: 'Cape Verde',
      iso2: 'CV',
      iso3: 'CPV',
      numericCode: '132',
    },
    {
      id: 41,
      name: 'Cayman Islands',
      iso2: 'KY',
      iso3: 'CYM',
      numericCode: '136',
    },
    {
      id: 42,
      name: 'Central African Republic',
      iso2: 'CF',
      iso3: 'CAF',
      numericCode: '140',
    },
    {
      id: 43,
      name: 'Chad',
      iso2: 'TD',
      iso3: 'TCD',
      numericCode: '148',
    },
    {
      id: 44,
      name: 'Chile',
      iso2: 'CL',
      iso3: 'CHL',
      numericCode: '152',
    },
    {
      id: 45,
      name: 'China',
      iso2: 'CN',
      iso3: 'CHN',
      numericCode: '156',
    },
    {
      id: 46,
      name: 'Christmas Island',
      iso2: 'CX',
      iso3: 'CXR',
      numericCode: '162',
    },
    {
      id: 47,
      name: 'Cocos (Keeling) Islands',
      iso2: 'CC',
      iso3: 'CCK',
      numericCode: '166',
    },
    {
      id: 48,
      name: 'Colombia',
      iso2: 'CO',
      iso3: 'COL',
      numericCode: '170',
    },
    {
      id: 49,
      name: 'Comoros',
      iso2: 'KM',
      iso3: 'COM',
      numericCode: '174',
    },
    {
      id: 50,
      name: 'Congo',
      iso2: 'CG',
      iso3: 'COG',
      numericCode: '178',
    },
    {
      id: 52,
      name: 'Cook Islands',
      iso2: 'CK',
      iso3: 'COK',
      numericCode: '184',
    },
    {
      id: 53,
      name: 'Costa Rica',
      iso2: 'CR',
      iso3: 'CRI',
      numericCode: '188',
    },
    {
      id: 55,
      name: 'Croatia',
      iso2: 'HR',
      iso3: 'HRV',
      numericCode: '191',
    },
    {
      id: 56,
      name: 'Cuba',
      iso2: 'CU',
      iso3: 'CUB',
      numericCode: '192',
    },
    {
      id: 249,
      name: 'Curaçao',
      iso2: 'CW',
      iso3: 'CUW',
      numericCode: '531',
    },
    {
      id: 57,
      name: 'Cyprus',
      iso2: 'CY',
      iso3: 'CYP',
      numericCode: '196',
    },
    {
      id: 58,
      name: 'Czech Republic',
      iso2: 'CZ',
      iso3: 'CZE',
      numericCode: '203',
    },
    {
      id: 51,
      name: 'Democratic Republic of the Congo',
      iso2: 'CD',
      iso3: 'COD',
      numericCode: '180',
    },
    {
      id: 59,
      name: 'Denmark',
      iso2: 'DK',
      iso3: 'DNK',
      numericCode: '208',
    },
    {
      id: 60,
      name: 'Djibouti',
      iso2: 'DJ',
      iso3: 'DJI',
      numericCode: '262',
    },
    {
      id: 61,
      name: 'Dominica',
      iso2: 'DM',
      iso3: 'DMA',
      numericCode: '212',
    },
    {
      id: 62,
      name: 'Dominican Republic',
      iso2: 'DO',
      iso3: 'DOM',
      numericCode: '214',
    },
    {
      id: 64,
      name: 'Ecuador',
      iso2: 'EC',
      iso3: 'ECU',
      numericCode: '218',
    },
    {
      id: 65,
      name: 'Egypt',
      iso2: 'EG',
      iso3: 'EGY',
      numericCode: '818',
    },
    {
      id: 66,
      name: 'El Salvador',
      iso2: 'SV',
      iso3: 'SLV',
      numericCode: '222',
    },
    {
      id: 67,
      name: 'Equatorial Guinea',
      iso2: 'GQ',
      iso3: 'GNQ',
      numericCode: '226',
    },
    {
      id: 68,
      name: 'Eritrea',
      iso2: 'ER',
      iso3: 'ERI',
      numericCode: '232',
    },
    {
      id: 69,
      name: 'Estonia',
      iso2: 'EE',
      iso3: 'EST',
      numericCode: '233',
    },
    {
      id: 212,
      name: 'Eswatini',
      iso2: 'SZ',
      iso3: 'SWZ',
      numericCode: '748',
    },
    {
      id: 70,
      name: 'Ethiopia',
      iso2: 'ET',
      iso3: 'ETH',
      numericCode: '231',
    },
    {
      id: 71,
      name: 'Falkland Islands',
      iso2: 'FK',
      iso3: 'FLK',
      numericCode: '238',
    },
    {
      id: 72,
      name: 'Faroe Islands',
      iso2: 'FO',
      iso3: 'FRO',
      numericCode: '234',
    },
    {
      id: 73,
      name: 'Fiji Islands',
      iso2: 'FJ',
      iso3: 'FJI',
      numericCode: '242',
    },
    {
      id: 74,
      name: 'Finland',
      iso2: 'FI',
      iso3: 'FIN',
      numericCode: '246',
    },
    {
      id: 75,
      name: 'France',
      iso2: 'FR',
      iso3: 'FRA',
      numericCode: '250',
    },
    {
      id: 76,
      name: 'French Guiana',
      iso2: 'GF',
      iso3: 'GUF',
      numericCode: '254',
    },
    {
      id: 77,
      name: 'French Polynesia',
      iso2: 'PF',
      iso3: 'PYF',
      numericCode: '258',
    },
    {
      id: 78,
      name: 'French Southern Territories',
      iso2: 'TF',
      iso3: 'ATF',
      numericCode: '260',
    },
    {
      id: 79,
      name: 'Gabon',
      iso2: 'GA',
      iso3: 'GAB',
      numericCode: '266',
    },
    {
      id: 81,
      name: 'Georgia',
      iso2: 'GE',
      iso3: 'GEO',
      numericCode: '268',
    },
    {
      id: 82,
      name: 'Germany',
      iso2: 'DE',
      iso3: 'DEU',
      numericCode: '276',
    },
    {
      id: 83,
      name: 'Ghana',
      iso2: 'GH',
      iso3: 'GHA',
      numericCode: '288',
    },
    {
      id: 84,
      name: 'Gibraltar',
      iso2: 'GI',
      iso3: 'GIB',
      numericCode: '292',
    },
    {
      id: 85,
      name: 'Greece',
      iso2: 'GR',
      iso3: 'GRC',
      numericCode: '300',
    },
    {
      id: 86,
      name: 'Greenland',
      iso2: 'GL',
      iso3: 'GRL',
      numericCode: '304',
    },
    {
      id: 87,
      name: 'Grenada',
      iso2: 'GD',
      iso3: 'GRD',
      numericCode: '308',
    },
    {
      id: 88,
      name: 'Guadeloupe',
      iso2: 'GP',
      iso3: 'GLP',
      numericCode: '312',
    },
    {
      id: 89,
      name: 'Guam',
      iso2: 'GU',
      iso3: 'GUM',
      numericCode: '316',
    },
    {
      id: 90,
      name: 'Guatemala',
      iso2: 'GT',
      iso3: 'GTM',
      numericCode: '320',
    },
    {
      id: 91,
      name: 'Guernsey',
      iso2: 'GG',
      iso3: 'GGY',
      numericCode: '831',
    },
    {
      id: 92,
      name: 'Guinea',
      iso2: 'GN',
      iso3: 'GIN',
      numericCode: '324',
    },
    {
      id: 93,
      name: 'Guinea-Bissau',
      iso2: 'GW',
      iso3: 'GNB',
      numericCode: '624',
    },
    {
      id: 94,
      name: 'Guyana',
      iso2: 'GY',
      iso3: 'GUY',
      numericCode: '328',
    },
    {
      id: 95,
      name: 'Haiti',
      iso2: 'HT',
      iso3: 'HTI',
      numericCode: '332',
    },
    {
      id: 96,
      name: 'Heard Island and McDonald Islands',
      iso2: 'HM',
      iso3: 'HMD',
      numericCode: '334',
    },
    {
      id: 97,
      name: 'Honduras',
      iso2: 'HN',
      iso3: 'HND',
      numericCode: '340',
    },
    {
      id: 98,
      name: 'Hong Kong S.A.R.',
      iso2: 'HK',
      iso3: 'HKG',
      numericCode: '344',
    },
    {
      id: 99,
      name: 'Hungary',
      iso2: 'HU',
      iso3: 'HUN',
      numericCode: '348',
    },
    {
      id: 100,
      name: 'Iceland',
      iso2: 'IS',
      iso3: 'ISL',
      numericCode: '352',
    },
    {
      id: 101,
      name: 'India',
      iso2: 'IN',
      iso3: 'IND',
      numericCode: '356',
    },
    {
      id: 102,
      name: 'Indonesia',
      iso2: 'ID',
      iso3: 'IDN',
      numericCode: '360',
    },
    {
      id: 103,
      name: 'Iran',
      iso2: 'IR',
      iso3: 'IRN',
      numericCode: '364',
    },
    {
      id: 104,
      name: 'Iraq',
      iso2: 'IQ',
      iso3: 'IRQ',
      numericCode: '368',
    },
    {
      id: 105,
      name: 'Ireland',
      iso2: 'IE',
      iso3: 'IRL',
      numericCode: '372',
    },
    {
      id: 106,
      name: 'Israel',
      iso2: 'IL',
      iso3: 'ISR',
      numericCode: '376',
    },
    {
      id: 107,
      name: 'Italy',
      iso2: 'IT',
      iso3: 'ITA',
      numericCode: '380',
    },
    {
      id: 54,
      name: 'Ivory Coast',
      iso2: 'CI',
      iso3: 'CIV',
      numericCode: '384',
    },
    {
      id: 108,
      name: 'Jamaica',
      iso2: 'JM',
      iso3: 'JAM',
      numericCode: '388',
    },
    {
      id: 109,
      name: 'Japan',
      iso2: 'JP',
      iso3: 'JPN',
      numericCode: '392',
    },
    {
      id: 110,
      name: 'Jersey',
      iso2: 'JE',
      iso3: 'JEY',
      numericCode: '832',
    },
    {
      id: 111,
      name: 'Jordan',
      iso2: 'JO',
      iso3: 'JOR',
      numericCode: '400',
    },
    {
      id: 112,
      name: 'Kazakhstan',
      iso2: 'KZ',
      iso3: 'KAZ',
      numericCode: '398',
    },
    {
      id: 113,
      name: 'Kenya',
      iso2: 'KE',
      iso3: 'KEN',
      numericCode: '404',
    },
    {
      id: 114,
      name: 'Kiribati',
      iso2: 'KI',
      iso3: 'KIR',
      numericCode: '296',
    },
    {
      id: 248,
      name: 'Kosovo',
      iso2: 'XK',
      iso3: 'XKX',
      numericCode: '926',
    },
    {
      id: 117,
      name: 'Kuwait',
      iso2: 'KW',
      iso3: 'KWT',
      numericCode: '414',
    },
    {
      id: 118,
      name: 'Kyrgyzstan',
      iso2: 'KG',
      iso3: 'KGZ',
      numericCode: '417',
    },
    {
      id: 119,
      name: 'Laos',
      iso2: 'LA',
      iso3: 'LAO',
      numericCode: '418',
    },
    {
      id: 120,
      name: 'Latvia',
      iso2: 'LV',
      iso3: 'LVA',
      numericCode: '428',
    },
    {
      id: 121,
      name: 'Lebanon',
      iso2: 'LB',
      iso3: 'LBN',
      numericCode: '422',
    },
    {
      id: 122,
      name: 'Lesotho',
      iso2: 'LS',
      iso3: 'LSO',
      numericCode: '426',
    },
    {
      id: 123,
      name: 'Liberia',
      iso2: 'LR',
      iso3: 'LBR',
      numericCode: '430',
    },
    {
      id: 124,
      name: 'Libya',
      iso2: 'LY',
      iso3: 'LBY',
      numericCode: '434',
    },
    {
      id: 125,
      name: 'Liechtenstein',
      iso2: 'LI',
      iso3: 'LIE',
      numericCode: '438',
    },
    {
      id: 126,
      name: 'Lithuania',
      iso2: 'LT',
      iso3: 'LTU',
      numericCode: '440',
    },
    {
      id: 127,
      name: 'Luxembourg',
      iso2: 'LU',
      iso3: 'LUX',
      numericCode: '442',
    },
    {
      id: 128,
      name: 'Macau S.A.R.',
      iso2: 'MO',
      iso3: 'MAC',
      numericCode: '446',
    },
    {
      id: 130,
      name: 'Madagascar',
      iso2: 'MG',
      iso3: 'MDG',
      numericCode: '450',
    },
    {
      id: 131,
      name: 'Malawi',
      iso2: 'MW',
      iso3: 'MWI',
      numericCode: '454',
    },
    {
      id: 132,
      name: 'Malaysia',
      iso2: 'MY',
      iso3: 'MYS',
      numericCode: '458',
    },
    {
      id: 133,
      name: 'Maldives',
      iso2: 'MV',
      iso3: 'MDV',
      numericCode: '462',
    },
    {
      id: 134,
      name: 'Mali',
      iso2: 'ML',
      iso3: 'MLI',
      numericCode: '466',
    },
    {
      id: 135,
      name: 'Malta',
      iso2: 'MT',
      iso3: 'MLT',
      numericCode: '470',
    },
    {
      id: 136,
      name: 'Man (Isle of)',
      iso2: 'IM',
      iso3: 'IMN',
      numericCode: '833',
    },
    {
      id: 137,
      name: 'Marshall Islands',
      iso2: 'MH',
      iso3: 'MHL',
      numericCode: '584',
    },
    {
      id: 138,
      name: 'Martinique',
      iso2: 'MQ',
      iso3: 'MTQ',
      numericCode: '474',
    },
    {
      id: 139,
      name: 'Mauritania',
      iso2: 'MR',
      iso3: 'MRT',
      numericCode: '478',
    },
    {
      id: 140,
      name: 'Mauritius',
      iso2: 'MU',
      iso3: 'MUS',
      numericCode: '480',
    },
    {
      id: 141,
      name: 'Mayotte',
      iso2: 'YT',
      iso3: 'MYT',
      numericCode: '175',
    },
    {
      id: 142,
      name: 'Mexico',
      iso2: 'MX',
      iso3: 'MEX',
      numericCode: '484',
    },
    {
      id: 143,
      name: 'Micronesia',
      iso2: 'FM',
      iso3: 'FSM',
      numericCode: '583',
    },
    {
      id: 144,
      name: 'Moldova',
      iso2: 'MD',
      iso3: 'MDA',
      numericCode: '498',
    },
    {
      id: 145,
      name: 'Monaco',
      iso2: 'MC',
      iso3: 'MCO',
      numericCode: '492',
    },
    {
      id: 146,
      name: 'Mongolia',
      iso2: 'MN',
      iso3: 'MNG',
      numericCode: '496',
    },
    {
      id: 147,
      name: 'Montenegro',
      iso2: 'ME',
      iso3: 'MNE',
      numericCode: '499',
    },
    {
      id: 148,
      name: 'Montserrat',
      iso2: 'MS',
      iso3: 'MSR',
      numericCode: '500',
    },
    {
      id: 149,
      name: 'Morocco',
      iso2: 'MA',
      iso3: 'MAR',
      numericCode: '504',
    },
    {
      id: 150,
      name: 'Mozambique',
      iso2: 'MZ',
      iso3: 'MOZ',
      numericCode: '508',
    },
    {
      id: 151,
      name: 'Myanmar',
      iso2: 'MM',
      iso3: 'MMR',
      numericCode: '104',
    },
    {
      id: 152,
      name: 'Namibia',
      iso2: 'NA',
      iso3: 'NAM',
      numericCode: '516',
    },
    {
      id: 153,
      name: 'Nauru',
      iso2: 'NR',
      iso3: 'NRU',
      numericCode: '520',
    },
    {
      id: 154,
      name: 'Nepal',
      iso2: 'NP',
      iso3: 'NPL',
      numericCode: '524',
    },
    {
      id: 156,
      name: 'Netherlands',
      iso2: 'NL',
      iso3: 'NLD',
      numericCode: '528',
    },
    {
      id: 157,
      name: 'New Caledonia',
      iso2: 'NC',
      iso3: 'NCL',
      numericCode: '540',
    },
    {
      id: 158,
      name: 'New Zealand',
      iso2: 'NZ',
      iso3: 'NZL',
      numericCode: '554',
    },
    {
      id: 159,
      name: 'Nicaragua',
      iso2: 'NI',
      iso3: 'NIC',
      numericCode: '558',
    },
    {
      id: 160,
      name: 'Niger',
      iso2: 'NE',
      iso3: 'NER',
      numericCode: '562',
    },
    {
      id: 161,
      name: 'Nigeria',
      iso2: 'NG',
      iso3: 'NGA',
      numericCode: '566',
    },
    {
      id: 162,
      name: 'Niue',
      iso2: 'NU',
      iso3: 'NIU',
      numericCode: '570',
    },
    {
      id: 163,
      name: 'Norfolk Island',
      iso2: 'NF',
      iso3: 'NFK',
      numericCode: '574',
    },
    {
      id: 115,
      name: 'North Korea',
      iso2: 'KP',
      iso3: 'PRK',
      numericCode: '408',
    },
    {
      id: 129,
      name: 'North Macedonia',
      iso2: 'MK',
      iso3: 'MKD',
      numericCode: '807',
    },
    {
      id: 164,
      name: 'Northern Mariana Islands',
      iso2: 'MP',
      iso3: 'MNP',
      numericCode: '580',
    },
    {
      id: 165,
      name: 'Norway',
      iso2: 'NO',
      iso3: 'NOR',
      numericCode: '578',
    },
    {
      id: 166,
      name: 'Oman',
      iso2: 'OM',
      iso3: 'OMN',
      numericCode: '512',
    },
    {
      id: 167,
      name: 'Pakistan',
      iso2: 'PK',
      iso3: 'PAK',
      numericCode: '586',
    },
    {
      id: 168,
      name: 'Palau',
      iso2: 'PW',
      iso3: 'PLW',
      numericCode: '585',
    },
    {
      id: 169,
      name: 'Palestinian Territory Occupied',
      iso2: 'PS',
      iso3: 'PSE',
      numericCode: '275',
    },
    {
      id: 170,
      name: 'Panama',
      iso2: 'PA',
      iso3: 'PAN',
      numericCode: '591',
    },
    {
      id: 171,
      name: 'Papua New Guinea',
      iso2: 'PG',
      iso3: 'PNG',
      numericCode: '598',
    },
    {
      id: 172,
      name: 'Paraguay',
      iso2: 'PY',
      iso3: 'PRY',
      numericCode: '600',
    },
    {
      id: 173,
      name: 'Peru',
      iso2: 'PE',
      iso3: 'PER',
      numericCode: '604',
    },
    {
      id: 174,
      name: 'Philippines',
      iso2: 'PH',
      iso3: 'PHL',
      numericCode: '608',
    },
    {
      id: 175,
      name: 'Pitcairn Island',
      iso2: 'PN',
      iso3: 'PCN',
      numericCode: '612',
    },
    {
      id: 176,
      name: 'Poland',
      iso2: 'PL',
      iso3: 'POL',
      numericCode: '616',
    },
    {
      id: 177,
      name: 'Portugal',
      iso2: 'PT',
      iso3: 'PRT',
      numericCode: '620',
    },
    {
      id: 178,
      name: 'Puerto Rico',
      iso2: 'PR',
      iso3: 'PRI',
      numericCode: '630',
    },
    {
      id: 179,
      name: 'Qatar',
      iso2: 'QA',
      iso3: 'QAT',
      numericCode: '634',
    },
    {
      id: 180,
      name: 'Reunion',
      iso2: 'RE',
      iso3: 'REU',
      numericCode: '638',
    },
    {
      id: 181,
      name: 'Romania',
      iso2: 'RO',
      iso3: 'ROU',
      numericCode: '642',
    },
    {
      id: 182,
      name: 'Russia',
      iso2: 'RU',
      iso3: 'RUS',
      numericCode: '643',
    },
    {
      id: 183,
      name: 'Rwanda',
      iso2: 'RW',
      iso3: 'RWA',
      numericCode: '646',
    },
    {
      id: 184,
      name: 'Saint Helena',
      iso2: 'SH',
      iso3: 'SHN',
      numericCode: '654',
    },
    {
      id: 185,
      name: 'Saint Kitts and Nevis',
      iso2: 'KN',
      iso3: 'KNA',
      numericCode: '659',
    },
    {
      id: 186,
      name: 'Saint Lucia',
      iso2: 'LC',
      iso3: 'LCA',
      numericCode: '662',
    },
    {
      id: 187,
      name: 'Saint Pierre and Miquelon',
      iso2: 'PM',
      iso3: 'SPM',
      numericCode: '666',
    },
    {
      id: 188,
      name: 'Saint Vincent and the Grenadines',
      iso2: 'VC',
      iso3: 'VCT',
      numericCode: '670',
    },
    {
      id: 189,
      name: 'Saint-Barthelemy',
      iso2: 'BL',
      iso3: 'BLM',
      numericCode: '652',
    },
    {
      id: 190,
      name: 'Saint-Martin (French part)',
      iso2: 'MF',
      iso3: 'MAF',
      numericCode: '663',
    },
    {
      id: 191,
      name: 'Samoa',
      iso2: 'WS',
      iso3: 'WSM',
      numericCode: '882',
    },
    {
      id: 192,
      name: 'San Marino',
      iso2: 'SM',
      iso3: 'SMR',
      numericCode: '674',
    },
    {
      id: 193,
      name: 'Sao Tome and Principe',
      iso2: 'ST',
      iso3: 'STP',
      numericCode: '678',
    },
    {
      id: 194,
      name: 'Saudi Arabia',
      iso2: 'SA',
      iso3: 'SAU',
      numericCode: '682',
    },
    {
      id: 195,
      name: 'Senegal',
      iso2: 'SN',
      iso3: 'SEN',
      numericCode: '686',
    },
    {
      id: 196,
      name: 'Serbia',
      iso2: 'RS',
      iso3: 'SRB',
      numericCode: '688',
    },
    {
      id: 197,
      name: 'Seychelles',
      iso2: 'SC',
      iso3: 'SYC',
      numericCode: '690',
    },
    {
      id: 198,
      name: 'Sierra Leone',
      iso2: 'SL',
      iso3: 'SLE',
      numericCode: '694',
    },
    {
      id: 199,
      name: 'Singapore',
      iso2: 'SG',
      iso3: 'SGP',
      numericCode: '702',
    },
    {
      id: 250,
      name: 'Sint Maarten (Dutch part)',
      iso2: 'SX',
      iso3: 'SXM',
      numericCode: '534',
    },
    {
      id: 200,
      name: 'Slovakia',
      iso2: 'SK',
      iso3: 'SVK',
      numericCode: '703',
    },
    {
      id: 201,
      name: 'Slovenia',
      iso2: 'SI',
      iso3: 'SVN',
      numericCode: '705',
    },
    {
      id: 202,
      name: 'Solomon Islands',
      iso2: 'SB',
      iso3: 'SLB',
      numericCode: '090',
    },
    {
      id: 203,
      name: 'Somalia',
      iso2: 'SO',
      iso3: 'SOM',
      numericCode: '706',
    },
    {
      id: 204,
      name: 'South Africa',
      iso2: 'ZA',
      iso3: 'ZAF',
      numericCode: '710',
    },
    {
      id: 205,
      name: 'South Georgia',
      iso2: 'GS',
      iso3: 'SGS',
      numericCode: '239',
    },
    {
      id: 116,
      name: 'South Korea',
      iso2: 'KR',
      iso3: 'KOR',
      numericCode: '410',
    },
    {
      id: 206,
      name: 'South Sudan',
      iso2: 'SS',
      iso3: 'SSD',
      numericCode: '728',
    },
    {
      id: 207,
      name: 'Spain',
      iso2: 'ES',
      iso3: 'ESP',
      numericCode: '724',
    },
    {
      id: 208,
      name: 'Sri Lanka',
      iso2: 'LK',
      iso3: 'LKA',
      numericCode: '144',
    },
    {
      id: 209,
      name: 'Sudan',
      iso2: 'SD',
      iso3: 'SDN',
      numericCode: '729',
    },
    {
      id: 210,
      name: 'Suriname',
      iso2: 'SR',
      iso3: 'SUR',
      numericCode: '740',
    },
    {
      id: 211,
      name: 'Svalbard and Jan Mayen Islands',
      iso2: 'SJ',
      iso3: 'SJM',
      numericCode: '744',
    },
    {
      id: 213,
      name: 'Sweden',
      iso2: 'SE',
      iso3: 'SWE',
      numericCode: '752',
    },
    {
      id: 214,
      name: 'Switzerland',
      iso2: 'CH',
      iso3: 'CHE',
      numericCode: '756',
    },
    {
      id: 215,
      name: 'Syria',
      iso2: 'SY',
      iso3: 'SYR',
      numericCode: '760',
    },
    {
      id: 216,
      name: 'Taiwan',
      iso2: 'TW',
      iso3: 'TWN',
      numericCode: '158',
    },
    {
      id: 217,
      name: 'Tajikistan',
      iso2: 'TJ',
      iso3: 'TJK',
      numericCode: '762',
    },
    {
      id: 218,
      name: 'Tanzania',
      iso2: 'TZ',
      iso3: 'TZA',
      numericCode: '834',
    },
    {
      id: 219,
      name: 'Thailand',
      iso2: 'TH',
      iso3: 'THA',
      numericCode: '764',
    },
    {
      id: 17,
      name: 'The Bahamas',
      iso2: 'BS',
      iso3: 'BHS',
      numericCode: '044',
    },
    {
      id: 80,
      name: 'The Gambia',
      iso2: 'GM',
      iso3: 'GMB',
      numericCode: '270',
    },
    {
      id: 63,
      name: 'Timor-Leste',
      iso2: 'TL',
      iso3: 'TLS',
      numericCode: '626',
    },
    {
      id: 220,
      name: 'Togo',
      iso2: 'TG',
      iso3: 'TGO',
      numericCode: '768',
    },
    {
      id: 221,
      name: 'Tokelau',
      iso2: 'TK',
      iso3: 'TKL',
      numericCode: '772',
    },
    {
      id: 222,
      name: 'Tonga',
      iso2: 'TO',
      iso3: 'TON',
      numericCode: '776',
    },
    {
      id: 223,
      name: 'Trinidad and Tobago',
      iso2: 'TT',
      iso3: 'TTO',
      numericCode: '780',
    },
    {
      id: 224,
      name: 'Tunisia',
      iso2: 'TN',
      iso3: 'TUN',
      numericCode: '788',
    },
    {
      id: 225,
      name: 'Turkey',
      iso2: 'TR',
      iso3: 'TUR',
      numericCode: '792',
    },
    {
      id: 226,
      name: 'Turkmenistan',
      iso2: 'TM',
      iso3: 'TKM',
      numericCode: '795',
    },
    {
      id: 227,
      name: 'Turks and Caicos Islands',
      iso2: 'TC',
      iso3: 'TCA',
      numericCode: '796',
    },
    {
      id: 228,
      name: 'Tuvalu',
      iso2: 'TV',
      iso3: 'TUV',
      numericCode: '798',
    },
    {
      id: 229,
      name: 'Uganda',
      iso2: 'UG',
      iso3: 'UGA',
      numericCode: '800',
    },
    {
      id: 230,
      name: 'Ukraine',
      iso2: 'UA',
      iso3: 'UKR',
      numericCode: '804',
    },
    {
      id: 231,
      name: 'United Arab Emirates',
      iso2: 'AE',
      iso3: 'ARE',
      numericCode: '784',
    },
    {
      id: 232,
      name: 'United Kingdom',
      iso2: 'GB',
      iso3: 'GBR',
      numericCode: '826',
    },
    {
      id: 233,
      name: 'United States',
      iso2: 'US',
      iso3: 'USA',
      numericCode: '840',
    },
    {
      id: 234,
      name: 'United States Minor Outlying Islands',
      iso2: 'UM',
      iso3: 'UMI',
      numericCode: '581',
    },
    {
      id: 235,
      name: 'Uruguay',
      iso2: 'UY',
      iso3: 'URY',
      numericCode: '858',
    },
    {
      id: 236,
      name: 'Uzbekistan',
      iso2: 'UZ',
      iso3: 'UZB',
      numericCode: '860',
    },
    {
      id: 237,
      name: 'Vanuatu',
      iso2: 'VU',
      iso3: 'VUT',
      numericCode: '548',
    },
    {
      id: 238,
      name: 'Vatican City State (Holy See)',
      iso2: 'VA',
      iso3: 'VAT',
      numericCode: '336',
    },
    {
      id: 239,
      name: 'Venezuela',
      iso2: 'VE',
      iso3: 'VEN',
      numericCode: '862',
    },
    {
      id: 240,
      name: 'Vietnam',
      iso2: 'VN',
      iso3: 'VNM',
      numericCode: '704',
    },
    {
      id: 241,
      name: 'Virgin Islands (British)',
      iso2: 'VG',
      iso3: 'VGB',
      numericCode: '092',
    },
    {
      id: 242,
      name: 'Virgin Islands (US)',
      iso2: 'VI',
      iso3: 'VIR',
      numericCode: '850',
    },
    {
      id: 243,
      name: 'Wallis and Futuna Islands',
      iso2: 'WF',
      iso3: 'WLF',
      numericCode: '876',
    },
    {
      id: 244,
      name: 'Western Sahara',
      iso2: 'EH',
      iso3: 'ESH',
      numericCode: '732',
    },
    {
      id: 245,
      name: 'Yemen',
      iso2: 'YE',
      iso3: 'YEM',
      numericCode: '887',
    },
    {
      id: 246,
      name: 'Zambia',
      iso2: 'ZM',
      iso3: 'ZMB',
      numericCode: '894',
    },
    {
      id: 247,
      name: 'Zimbabwe',
      iso2: 'ZW',
      iso3: 'ZWE',
      numericCode: '716',
    },
  ]
}

export async function getCountryDataById(id: number): Promise<ICountry> {
  const list = await getCountryListData()
  console.debug('got country list', list)
  console.debug('id:', id)
  const country = list.find((c: ICountry) => c.id == id)
  if (!country) {
    throw new Error(`Can't find country '${id}'`)
  }
  return country
}
